require('../../modules/es6.reflect.construct');
module.exports = require('../../modules/_core').Reflect.construct;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/construct.js
// module id = K9ON
// module chunks = 3